import { render, staticRenderFns } from "./ExerciseTestsForm.vue?vue&type=template&id=6b1980d4&scoped=true"
import script from "./ExerciseTestsForm.vue?vue&type=script&lang=js"
export * from "./ExerciseTestsForm.vue?vue&type=script&lang=js"
import style0 from "./ExerciseTestsForm.vue?vue&type=style&index=0&id=6b1980d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1980d4",
  null
  
)

export default component.exports